import { render, staticRenderFns } from "./SettingsCardsWrapper.vue?vue&type=template&id=1597daed&scoped=true"
import script from "./SettingsCardsWrapper.vue?vue&type=script&lang=js"
export * from "./SettingsCardsWrapper.vue?vue&type=script&lang=js"
import style0 from "./SettingsCardsWrapper.vue?vue&type=style&index=0&id=1597daed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597daed",
  null
  
)

export default component.exports